export default "__VITE_ASSET__iSPXNRc$__"